// @ts-expect-error
import sup from 'markdown-it-sup';

import {MarkdownItPluginCb} from './typings';

export = sup as MarkdownItPluginCb;
